import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// A client-side route change cannot set an HTTP status. Ask nginx for the original
// document so unknown SPA navigation receives the same 403 as a direct URL visit.
export default function NotFoundPage() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (import.meta.env.PROD) window.location.replace(pathname + search + hash);
  }, [pathname, search, hash]);
  return (
    <main style={{ padding: 32, textAlign: 'center' }}><h1>403 Forbidden</h1></main>
  );
}
